import React from 'react';
import { useEffect } from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { useSearchTab } from '../SearchTabContext';

// Add this small CSS block for the underline animation
const styles = `
    .header-hybrid-2 .nav-link {
        position: relative;
        padding-bottom: 0.5rem;
        transition: color 0.3s ease;
    }
    .header-hybrid-2 .nav-link::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background-color: var(--primary); /* Uses the theme's primary color */
        transition: all 0.3s ease;
    }
    .header-hybrid-2 .nav-link.active::after,
    .header-hybrid-2 .nav-link:hover::after {
        width: 100%;
        left: 0;
    }
`;

const TemplateHeaderHybrid2 = () => {
    const { user } = useAuth();
    const { activeTab, setActiveTab } = useSearchTab();
    const logoUrl = user?.logo || 'https://via.placeholder.com/150x40?text=Your+Logo';

    const navLinks = [
        { id: 'home', name: 'Home' },
        { id: 'flights', name: 'Flights' },
        { id: 'hotels', name: 'Hotels' },
        { id: 'packages', name: 'Packages' },
        { id: 'about', name: 'About Us' },
        { id: 'contact', name: 'Contact' },
    ];
    // -------------------------

    // Inject the styles dynamically
    useEffect(() => {
        const styleTag = document.createElement('style');
        styleTag.innerHTML = styles;
        document.head.appendChild(styleTag);
        return () => { document.head.removeChild(styleTag); };
    }, []);

    // Define styles that use CSS variables
    const headerStyle = {
        backgroundColor: 'var(--header-bg-color, #f8f9fa)', // Use variable, fallback to light grey
    };
    const navLinkStyle = {
        color: 'var(--header-text-color, #333)', // Use variable, fallback to dark text
    };

    return (
        <header className="header-hybrid-2 navbar navbar-expand-lg shadow-sm px-4" style={headerStyle}>
            <a className="navbar-brand" href="#">
                <img src={logoUrl} alt="Company Logo" style={{ height: '40px' }} />
            </a>
            <div className="collapse navbar-collapse">
                <ul className="navbar-nav mx-auto gap-4">
                    {navLinks.map(link => (
                        <li className="nav-item" key={link.id}>
                            <a
                                className={`nav-link fs-5 ${activeTab === link.id ? 'active fw-bold' : ''}`}
                                href="#"
                                style={navLinkStyle} // Apply the dynamic text color
                                onClick={(e) => { e.preventDefault(); setActiveTab(link.id); }}
                            >
                                {link.name}
                            </a>
                        </li>
                    ))}
                </ul>
                {/* This button will be styled by the global .btn-primary class */}
                <a className="btn btn-primary rounded-pill px-4" href="#">Enquiry Now</a>
            </div>
        </header>
    );
};

export default TemplateHeaderHybrid2;